/*
  Приложение к пакету документов счёта: скан протокола собрания дома, в котором
  лежит помещение (21.10.2026, решение владельца).

  Скан идёт отдельным файлом, не склеенным с заявлением, - строка реестра
  компромиссов. Показывается только если скан у дома есть: пустого блока
  «приложений нет» кабинет не рисует, чтобы не обещать то, чего ждать не стоит.
*/

import { useEffect, useState } from 'react'

import { api } from '../api/client.js'
import { fileSize } from '../api/format.js'
import { Notice } from './Common.jsx'

export default function ProtocolScanAttachment({ accountId }) {
  const [info, setInfo] = useState(null)
  const [failure, setFailure] = useState(null)
  const [saving, setSaving] = useState(false)

  useEffect(() => {
    let alive = true
    api
      .accountProtocolScan(accountId)
      .then((answer) => alive && setInfo(answer))
      .catch((error) => alive && setFailure(error))
    return () => {
      alive = false
    }
  }, [accountId])

  async function save() {
    setSaving(true)
    setFailure(null)
    try {
      await api.downloadAccountProtocolScan(accountId, info.filename)
    } catch (error) {
      setFailure(error)
    } finally {
      setSaving(false)
    }
  }

  if (!info?.available) return <Notice error={failure} />

  return (
    <section className="section">
      <h2 className="section__title">Приложение к пакету</h2>
      <div className="card row row--between">
        <div>
          Протокол общего собрания собственников (скан)
          <div className="muted">
            {info.filename} · {fileSize(info.size_bytes)}
          </div>
        </div>
        <button type="button" className="button button--quiet" disabled={saving} onClick={save}>
          {saving ? 'Готовим...' : 'Скачать скан'}
        </button>
      </div>
      <Notice error={failure} />
    </section>
  )
}
